export const UPDATE_ENTITY_STATE = 'UPDATE_ENTITY_STATE';
export const DELETE_ENTITY_STATE = 'DELETE_ENTITY_STATE';
export const ALL_ENTITIES_LOADING = 'ALL_ENTITIES_LOADING';
export const ALL_ENTITIES_LOADED = 'ALL_ENTITIES_LOADED';
export const ALL_ENTITIES_LOAD_ERROR = 'ALL_ENTITIES_LOAD_ERROR';
export const ENTITY_DELETED = 'ENTITY_DELETED';
export const ENTITY_CREATING = 'ENTITY_CREATING';
export const ENTITY_CREATED = 'ENTITY_CREATED';
export const ENTITY_CREATION_FAILED = 'ENTITY_CREATION_FAILED';
export const ENTITY_DATA_LOADING = 'ENTITY_DATA_LOADING';
export const ENTITY_DATA_LOADED = 'ENTITY_DATA_LOADED';
export const ENTITY_DATA_LOAD_ERROR = 'ENTITY_DATA_LOAD_ERROR';
export const ENTITY_UPDATING = 'ENTITY_UPDATING';
export const ENTITY_UPDATED = 'ENTITY_UPDATED';
export const ENTITY_UPDATION_ERROR = 'ENTITY_UPDATION_ERROR';

//FIXME: no action and reducer for these actionTypes. useless constant.
export const HIERARCHICAL_ENTITY_DETAILS_LOADED = 'HIERARCHICAL_ENTITY_DETAILS_LOADED';
export const DELETE_HIERARCHICAL_CHILD_ENTITY = 'DELETE_HIERARCHICAL_CHILD_ENTITY';
export const ADD_CHILD_TO_CHILDREN_TABLE = 'ADD_CHILD_TO_CHILDREN_TABLE';
export const LIST_ENTITY_DETAILS_LOADED = 'LIST_ENTITY_DETAILS_LOADED';



// WEBPACK FOOTER //
// ./src/data/redux/entity_details/actiontypes.js